module.exports = __webpack_public_path__ + "img/LinkedIn.5cb60b12.png";